<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">{{linkName}}</h6> -
          <a :href="externalUrl" target="_new">{{externalUrl}}</a>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <span class="h3"></span>
        </b-card-header>
        <b-card-body>
          <iframe
              id="remoteIframe"
              :src="externalUrl"
              width="100%"
              frameborder="0"
              style="height: 70vh;"
          >
          </iframe>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import configDirective from "@/common/directive/config-directive";

export default {
  name: "IFramePage",
  components: {RouteBreadCrumb},
  data() {
    return {
      externalUrl: '',
      linkName: ''
    }
  },
  mounted() {

    console.log('path:',this.$route.path);
    this.reInitialize();
    this.$root.$on('showBroadBandActive', (res => {
      if (res) {
        console.log('URL:', res);
        this.externalUrl = res
      }
    }));
  },
  methods: {

    reInitialize() {
      let currentPath = this.$route.path.replace('/', '');
      //console.log('path:',currentPath);
      if (currentPath==='reports' && configDirective.getReportLink()) {
        this.externalUrl = configDirective.getReportLink();
        this.linkName = 'Reports';
        return;
      }

      let navigation = configDirective.getNavigationDetails();
      for (const topTab in navigation) {
         //console.log('topTab:',topTab);
        if (navigation.hasOwnProperty(topTab)) {
          if (navigation[topTab].hasOwnProperty('child')) {
            let childDropdown = navigation[topTab]['child'];
            for (const childTab in childDropdown) {
              //console.log('childTab:', childTab);
              if (childDropdown.hasOwnProperty(childTab)) {
                if (childDropdown[childTab].path && childDropdown[childTab].path.toLowerCase().indexOf(currentPath) > -1) {
                  this.showLink(currentPath, childDropdown[childTab]);
                  break;
                }
              }
            }
          } else {
            //console.log('navigation[topTab]:',navigation[topTab]);
            if (navigation[topTab].path.toLowerCase().indexOf(currentPath) > -1) {
              this.showLink(currentPath, navigation[topTab]);
              break;
            }
          }
        }
      }
    },
    showLink(path, item) {
      console.log('iframe path:', path);
      console.log('iframe item:', item);
      //if (item.url.toLowerCase().indexOf('src=')>-1) {
      this.externalUrl = item.url.split('src=')[1];
      this.linkName = item.name;
      // if (item.name==='Reports' && process.env.VUE_APP_ENVIRONMENT==='dev' && process.env.VUE_APP_CLIENT==='Cordova') {
      //   this.externalUrl ='http://localhost/php-reports/';
      // }
      //console.log('linkName:', this.linkName);
      //console.log('externalUrl:', this.externalUrl);
      if (typeof this.externalUrl !== 'undefined' && this.linkName.indexOf('Service Assurance') > -1) {
        //window.location.href=this.externalUrl;
        window.open(this.externalUrl, "_blank");
        this.$router.push({name: 'Home'});
      }
      //}
    }
  }
}
</script>
